var $ = require('jquery');

module.exports = {
	init: function () {
        $('.nav-toggle').on('click', function () {
            $('.header').toggleClass('active');
            $('.header-nav').toggleClass('active');
        });
	}
}